import { Authenticator } from '@aws-amplify/ui-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { LayoutWithProvider } from 'components/layout-with-provider';
import { AboutWealth } from 'components/pages/about-wealth';
import { AboutWellbeing } from 'components/pages/about-wellbeing/about-wellbeing';
import { AboutWorklife } from 'components/pages/about-worklife';
import { Help } from 'components/pages/help/help';
import { QuestionEight } from 'components/pages/question-eight';
import { QuestionEighteen } from 'components/pages/question-eighteen';
import { QuestionEleven } from 'components/pages/question-eleven';
import { QuestionFifteen } from 'components/pages/question-fifteen';
import { QuestionFive } from 'components/pages/question-five';
import { QuestionFour } from 'components/pages/question-four';
import { QuestionFourteen } from 'components/pages/question-fourteen';
import { QuestionNine } from 'components/pages/question-nine';
import { QuestionOne } from 'components/pages/question-one';
import { QuestionSeven } from 'components/pages/question-seven';
import { QuestionSeventeen } from 'components/pages/question-seventeen';
import { QuestionSix } from 'components/pages/question-six';
import { QuestionSixteen } from 'components/pages/question-sixteen';
import { QuestionTen } from 'components/pages/question-ten';
import { QuestionThirteen } from 'components/pages/question-thirteen';
import { QuestionThree } from 'components/pages/question-three';
import { QuestionTwelve } from 'components/pages/question-twelve';
import { QuestionTwo } from 'components/pages/question-two';
import { Results } from 'components/pages/results';
import { RetirementIntranet } from 'components/pages/retirement-intranet';
import { Start } from 'components/pages/start';
import { BrowserRouter, Route, Routes } from 'react-router';
import './App.css';
import { Layout } from './components/layout';
import { Login } from './components/login';
import { Home } from './components/pages/home';
import { RequireAuth } from './components/require-auth';

const MyRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<LayoutWithProvider />}>
                <Route
                    path="/about-wellbeing"
                    element={
                        <RequireAuth>
                            <AboutWellbeing />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/question-one"
                    element={
                        <RequireAuth>
                            <QuestionOne />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/question-two"
                    element={
                        <RequireAuth>
                            <QuestionTwo />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/question-three"
                    element={
                        <RequireAuth>
                            <QuestionThree />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/question-four"
                    element={
                        <RequireAuth>
                            <QuestionFour />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/question-five"
                    element={
                        <RequireAuth>
                            <QuestionFive />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/question-six"
                    element={
                        <RequireAuth>
                            <QuestionSix />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/about-worklife"
                    element={
                        <RequireAuth>
                            <AboutWorklife />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/question-seven"
                    element={
                        <RequireAuth>
                            <QuestionSeven />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/question-eight"
                    element={
                        <RequireAuth>
                            <QuestionEight />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/question-nine"
                    element={
                        <RequireAuth>
                            <QuestionNine />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/question-ten"
                    element={
                        <RequireAuth>
                            <QuestionTen />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/question-eleven"
                    element={
                        <RequireAuth>
                            <QuestionEleven />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/question-twelve"
                    element={
                        <RequireAuth>
                            <QuestionTwelve />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/about-wealth"
                    element={
                        <RequireAuth>
                            <AboutWealth />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/question-thirteen"
                    element={
                        <RequireAuth>
                            <QuestionThirteen />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/question-fourteen"
                    element={
                        <RequireAuth>
                            <QuestionFourteen />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/question-fifteen"
                    element={
                        <RequireAuth>
                            <QuestionFifteen />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/question-sixteen"
                    element={
                        <RequireAuth>
                            <QuestionSixteen />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/question-seventeen"
                    element={
                        <RequireAuth>
                            <QuestionSeventeen />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/question-eighteen"
                    element={
                        <RequireAuth>
                            <QuestionEighteen />
                        </RequireAuth>
                    }
                />
            </Route>
            <Route path="/" element={<Layout />}>
                <Route
                    index
                    element={
                        <RequireAuth>
                            <Home />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/start"
                    element={
                        <RequireAuth>
                            <Start />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/results"
                    element={
                        <RequireAuth>
                            <Results />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/help"
                    element={
                        <RequireAuth>
                            <Help />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/further-information"
                    element={
                        <RequireAuth>
                            <RetirementIntranet />
                        </RequireAuth>
                    }
                />

                <Route path="/login" element={<Login />} />
            </Route>
        </Routes>
    );
};

export const App = () => (
    <Authenticator.Provider>
        <BrowserRouter>
            <MyRoutes />
        </BrowserRouter>
    </Authenticator.Provider>
);
